<div class="container">
  <div class="admin-page-header">
    <h1 class="admin-page-title">Loggers</h1>
    <div class="summary-chip">Total: {{restoredLogs.length}}</div>
  </div>

  <mat-card class="table-card">
    <app-filter [filters]="fieldFilters" btLabel="Buscar" (submit)="getLoggers()"></app-filter>
  </mat-card>

  <mat-card class="table-card logger-card">
    <log-monitor
      theme="dark"
      title="Loggers"
      [animated]="true"
      [icons]="true"
      [history]="restoredLogs">
    </log-monitor>
  </mat-card>
</div>
